var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"rel"},[_c('div',{staticClass:"flapping-kolibri"},[_c('KLogo',{attrs:{"size":"250","animate":true,"altText":_vm.$tr('kolibriLoading')}})],1)])])}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }